import { render, staticRenderFns } from "./AssistantWidget.vue?vue&type=template&id=1cfe8636&scoped=true"
import script from "./AssistantWidget.vue?vue&type=script&lang=js"
export * from "./AssistantWidget.vue?vue&type=script&lang=js"
import style0 from "./AssistantWidget.vue?vue&type=style&index=0&id=1cfe8636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe8636",
  null
  
)

export default component.exports